(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-adaptive-banner"] && !Shopify.designMode) return;
  try {
    
  class AdaptiveBanner {
    constructor(wrapper) {
      this.wrapper = wrapper;
      this.container = this.wrapper.querySelector('.adaptive-banner__container');
      this.slides = Array.from(this.container.children);
      this.nextBtn = this.wrapper.querySelector('.adaptive-banner__button--next');
      this.prevBtn = this.wrapper.querySelector('.adaptive-banner__button--prev');
      this.dotsContainer = this.wrapper.querySelector('.adaptive-banner__dots');
      this.currentIndex = 0;
      this.autoplay = this.wrapper.querySelector('.adaptive-banner').dataset.autoplay === 'true';
      this.speed = parseInt(this.wrapper.querySelector('.adaptive-banner').dataset.speed, 10);
      this.autoplayInterval = null;

      if (this.slides.length < 2) {
        if(this.nextBtn) this.nextBtn.style.display = 'none';
        if(this.prevBtn) this.prevBtn.style.display = 'none';
        if(this.dotsContainer) this.dotsContainer.style.display = 'none';
        return;
      }
      
      this.init();
    }

    init() {
      this.setupDots();
      this.update();

      this.nextBtn.addEventListener('click', () => this.next());
      this.prevBtn.addEventListener('click', () => this.prev());

      if (this.autoplay) {
        this.startAutoplay();
        this.wrapper.addEventListener('mouseenter', () => this.stopAutoplay());
        this.wrapper.addEventListener('mouseleave', () => this.startAutoplay());
      }
    }

    goTo(index) {
      this.currentIndex = index;
      this.container.style.transform = `translateX(-${index * 100}%)`;
      this.dots.forEach((dot, i) => dot.classList.toggle('active', i === index));
    }

    next() {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.goTo(nextIndex);
    }
    
    prev() {
      const prevIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
      this.goTo(prevIndex);
    }
    
    setupDots() {
      this.slides.forEach((_, index) => {
        const button = document.createElement('button');
        button.addEventListener('click', () => this.goTo(index));
        this.dotsContainer.appendChild(button);
      });
      this.dots = Array.from(this.dotsContainer.children);
    }

    update() {
      this.goTo(this.currentIndex);
    }
    
    startAutoplay() {
      if(this.autoplayInterval) clearInterval(this.autoplayInterval);
      this.autoplayInterval = setInterval(() => this.next(), this.speed);
    }

    stopAutoplay() {
      clearInterval(this.autoplayInterval);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.adaptive-banner-wrapper').forEach(wrapper => {
      new AdaptiveBanner(wrapper);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
/* Sticky Header + REGLA: hover SOLO para 1er nivel, subniveles SOLO con clic */
class StickyHeader extends HTMLElement{
  constructor(){ super(); }
  connectedCallback(){
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type')==='always' || this.getAttribute('data-sticky-type')==='reduce-logo-size';
    this.headerBounds = {};
    this.setHeaderHeight();
    window.matchMedia('(max-width:990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    if(this.headerIsAlwaysSticky){ this.header.classList.add('shopify-section-header-sticky'); }
    this.currentScrollTop = 0; this.preventReveal = false; this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.createObserver();

    /* ------ Apertura por HOVER SOLO primer nivel (desktop) ------ */
    if (window.matchMedia('(hover:hover) and (min-width: 990px)').matches){
      const topLevelDetails = document.querySelectorAll('.header__inline-menu > .list-menu--inline > li > details');
      topLevelDetails.forEach((d)=>{
        let t;
        d.addEventListener('mouseenter', ()=>{
          clearTimeout(t);
          d.setAttribute('open','');
          d.classList.add('is-hover-open');
        });
        d.addEventListener('mouseleave', ()=>{
          t = setTimeout(()=>{
            d.removeAttribute('open');
            d.classList.remove('is-hover-open');
          }, 220);
        });
        d.addEventListener('focusin', ()=>{
          d.setAttribute('open','');
          d.classList.add('is-hover-open');
        });
        d.addEventListener('focusout', (e)=>{
          if(!d.contains(e.relatedTarget)){
            d.removeAttribute('open');
            d.classList.remove('is-hover-open');
          }
        });
      });

      /* IMPORTANTÍSIMO: evitar que niveles 2/3 se abran por hover.
         Quitamos cualquier listener heredado en details anidados. */
      const nested = document.querySelectorAll('.header__inline-menu .header__submenu details');
      nested.forEach((dd)=>{
        dd.addEventListener('mouseenter', (e)=>{ /* no-op: se requiere clic */ }, true);
        dd.addEventListener('mouseleave', (e)=>{ /* no-op */ }, true);
      });
    }
  }

  setHeaderHeight(){ document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`); }
  disconnectedCallback(){ this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp); window.removeEventListener('scroll', this.onScrollHandler); }
  createObserver(){ let o=new IntersectionObserver((e,ob)=>{ this.headerBounds = e[0].intersectionRect; ob.disconnect(); }); o.observe(this.header); }
  onScroll(){
    const y = window.pageYOffset || document.documentElement.scrollTop;
    if(this.predictiveSearch && this.predictiveSearch.isOpen) return;
    if(y > this.currentScrollTop && y > this.headerBounds.bottom){
      this.header.classList.add('scrolled-past-header'); if(this.preventHide) return; requestAnimationFrame(this.hide.bind(this));
    }else if(y < this.currentScrollTop && y > this.headerBounds.bottom){
      this.header.classList.add('scrolled-past-header');
      if(!this.preventReveal){ requestAnimationFrame(this.reveal.bind(this)); }
      else{
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(()=>{ this.preventReveal=false; }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    }else if(y <= this.headerBounds.top){
      this.header.classList.remove('scrolled-past-header'); requestAnimationFrame(this.reset.bind(this));
    }
    this.currentScrollTop = y;
  }
  hide(){ if(this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-hidden','shopify-section-header-sticky'); this.closeMenuDisclosure(); this.closeSearchModal(); }
  reveal(){ if(this.headerIsAlwaysSticky) return; this.header.classList.add('shopify-section-header-sticky','animate'); this.header.classList.remove('shopify-section-header-hidden'); }
  reset(){ if(this.headerIsAlwaysSticky) return; this.header.classList.remove('shopify-section-header-hidden','shopify-section-header-sticky','animate'); }
  closeMenuDisclosure(){ this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu'); this.disclosures.forEach((d)=>d.close()); }
  closeSearchModal(){ this.searchModal = this.searchModal || this.header.querySelector('details-modal'); this.searchModal.close(false); }
}
customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
